import React from "react";

export type CategoryType = "PROJECT" | "ENTERTAINMENT" | "RANDOM" | "IMAGE";

export type BaseItem = {
id: number;
category: CategoryType;
author: string;
handle: string;
timestamp: string;
content: string;
stats: {
    comments: number;
    retweets: number;
    likes: number;
    views: string;
};
};

export type ProjectItem = BaseItem & {
type: "project";
projectData: {
    name: string;
    icon: React.ReactNode;
    playable: boolean;
    path?: string;
    mode: "playable" | "video";
    banner_image?: string;
};
videoUrl?: string;
imageUrl?: string;
};

export type VideoItem = BaseItem & {
type: "video";
videoUrl: string;
};

export type ImageItem = BaseItem & {
type: "image";
imageUrl: string;
};

export type TextItem = BaseItem & {
type: "text";
};

export type FeedItem = ProjectItem | VideoItem | ImageItem | TextItem;

export const feedItems: FeedItem[] = [

{
    id: 80,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2025_Tangerang_Karawaci",
    imageUrl: "dog/2025_Tangerang_Karawaci.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},
{
    id: 79,
    type: "image",
    category: "IMAGE",
    author: "System K13",
    handle: "@System_K13",
    timestamp: "K_3",
    content: "2026_Sumatera_Utara_Parapat",
    imageUrl: "dog/2026_Sumatera_Utara_Parapat.jpg",
    stats: { comments: 2, retweets: 5, likes: 200, views: "10K" },
},



];